/* ─────────────────────────────────────────────────────────────────────────────────────────────
   IAS · ias-instant.js — NOS IV · Area 5: the product page's Add to Cart opens the cart drawer AT THE TAP (<300 ms) with
   "Adding …", while Dawn's own product form does the real add in the background (its route, its sections, its events).
   Dawn re-renders the drawer when Shopify answers → "Added ✓". If Shopify refuses (sold out / 422), Dawn publishes
   cartError → the drawer closes again and Dawn's own inline error shows on the page (roll back). The protected button is
   untouched: a disabled / aria-disabled / already-loading button never opens anything. Main product form only (not quick add).
   ───────────────────────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  var PSE = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;
  var pending = null;
  function drawer() { return document.querySelector('cart-drawer'); }
  function flash(state, text) {
    var d = drawer(), inner = d && d.querySelector('.drawer__inner'); if (!inner) return;
    var el = inner.querySelector(':scope > .ias-add-flash');
    if (!text) { if (el) el.remove(); return; }
    if (!el) { el = document.createElement('p'); el.className = 'ias-add-flash'; el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite'); inner.insertBefore(el, inner.firstChild); }
    el.dataset.state = state; el.textContent = text;
  }
  document.addEventListener('submit', function (e) {
    var form = e.target; if (!form || !form.closest) return;
    var pf = form.closest('product-form'); if (!pf || pf.closest('.quick-add-modal, quick-add-modal, .card-wrapper')) return;
    if (!form.closest('[id^="MainProduct-"], .product, product-info')) return;
    var btn = form.querySelector('[type="submit"], .product-form__submit');
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true' || btn.classList.contains('loading')) return;
    var d = drawer(); if (!d || !d.open) return;
    var h = form.closest('product-info, .product, main') || document;
    var title = (h.querySelector('.product__title h1') || h.querySelector('h1') || {}).textContent || 'your flute';
    title = title.replace(/\s+/g, ' ').trim();
    pending = { t: Date.now(), title: title };
    try { d.setActiveElement && d.setActiveElement(btn); } catch (err) {}
    d.open(btn); d.classList.add('ias-adding');
    flash('adding', 'Adding ' + title + '…');
  }, true);   // capture: open before Dawn's handler starts its network call
  if (typeof subscribe === 'function' && PSE) {
    subscribe(PSE.cartUpdate, function (ev) {
      if (!pending || !ev || ev.source !== 'product-form') return;
      var t = pending.title; pending = null;
      var d = drawer(); if (d) d.classList.remove('ias-adding');
      setTimeout(function () { flash('added', 'Added ✓ ' + t); setTimeout(function () { flash(); }, 2600); }, 0);
    });
    if (PSE.cartError) subscribe(PSE.cartError, function () {
      if (!pending) return; pending = null;
      var d = drawer(); flash(); if (d) { d.classList.remove('ias-adding'); d.close && d.close(); }
    });
  }
})();
